import type React from 'react';
import { ModalState } from './state/bank-id/modal-state';
import { useTranslator } from 'tradera/lang/translate';
import { Button } from 'tradera/components/atoms/button/button';
import OpenOnDeviceButton from './open-on-device-button';
import { Space } from 'tradera/components/atoms/space/space';

type FooterActionsProps = {
    onClose: () => void;
    setMobileFlow: React.Dispatch<React.SetStateAction<boolean>>;
    modalState: ModalState;
    autoStartToken?: string | null;
    mobileFlow: boolean;
    memberId?: number;
    purpose: string;
};

const CancelButton = ({ onClose }: Pick<FooterActionsProps, 'onClose'>) => {
    const { t } = useTranslator();

    return (
        <Button theme="link" onClick={onClose} className="mt-2">
            {t('bankIdModal_Cancel')}
        </Button>
    );
};

export const FooterActions = ({
    onClose,
    modalState,
    autoStartToken,
    mobileFlow,
    setMobileFlow,
    memberId,
    purpose
}: FooterActionsProps) => {
    const { t } = useTranslator();

    switch (modalState) {
        case ModalState.IN_PROGRESS:
            return (
                <Space direction="vertical" gap={2} align="center">
                    <OpenOnDeviceButton
                        autoStartToken={autoStartToken}
                        memberId={memberId}
                        purpose={purpose}
                        fluid
                        variant={!mobileFlow ? 'outline' : 'filled'}
                    />
                    {mobileFlow && (
                        <Button
                            theme="primary"
                            variant="outline"
                            fluid
                            onClick={() => setMobileFlow((state) => !state)}>
                            {t('bankIdModal_OpenOnOtherDevice')}
                        </Button>
                    )}
                    <CancelButton onClose={onClose} />
                </Space>
            );
        case ModalState.ERROR:
            return (
                <div className="text-center">
                    <CancelButton onClose={onClose} />
                </div>
            );
    }

    return null;
};
